<template>
  <div class="bg-step pt-100  mb-pt-60">
      <div class="container">
          <div class="pr-85 pl-85 mb-pr-0 mb-pl-0 container-step">
            <div class="flex justify-start mb-db">
               <div class="card-box box1">
              <div class="flex items-center mb-20">
                <img
                  :src="`${ASSETS_CDN}/images/home/icons/step-enquire-v2.svg`"
                  class="w-36"
                />
                <h2 class="fw-900 fs-36 lh-36 ml-20 mb-fs-28 mb-lh-28">1. Explore</h2>
              </div>
              <div class="fs-16 lh-24 fw-500">
                Every trip starts differently and Designer Journeys is here to guide through the process to design your extraordinary trip.  Take the first step by exploring our gallery of 2,000+ itineraries or telling us exactly where you want to go and what you want to do and we’ll build it exactly for you.</div>
            </div>
            </div>
            <div class="flex justify-end mb-db">
                <div class="card-box box2">
                  <div class="box-line">
                    <div class="flex items-center mb-20">
                      <img
                  :src="`${ASSETS_CDN}/images/home/icons/step-build-v2.svg`"
                  class="w-36"
                />
                      <h2 class="fw-900 fs-36 lh-36 ml-20 mb-fs-28 mb-lh-28">2. Design</h2>
                    </div>
                    <div class="fs-16 lh-24 fw-500">
                      Work with your Local Designer to design or customise your itinerary so it is exactly what you want from your extraordinary trip.  Our Local Designers will give you access to exclusive experiences, restaurants, hotels and more as well as helping you avoid pitfalls, to ensure your trip is incredible.</div>
                  </div>
                </div>
            </div>
            <div class="flex justify-start mb-db">
              <div class="card-box box3">
                <div class="flex items-center mb-20">
                  <img
                  :src="`${ASSETS_CDN}/images/home/icons/step-book-v2.svg`"
                  class="w-36"
                />
                  <h2 class="fw-900 fs-36 lh-36 ml-20 mb-fs-28 mb-lh-28">3. Book</h2>
                </div>
                <div class="fs-16 lh-24 fw-500">
                  With the comfort of knowing your local designer will be there for you every step of the way you can experience your extraordinary trip with confidence.  Our purpose is to make sure your trip is extraordinary.</div>
              </div>
            </div>
          </div>
    </div>
    <div class="linear-img">
      <div class="height-shadow"></div>
      <img class="img-cover" :src="`${$assetsCdn}/images/howitworks/bg-container.jpg`" alt="bg-container">
    </div>
  </div>
</template>
<script setup>
import {assetCDN} from '~/helper'
const ASSETS_CDN = assetCDN()
</script>
<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .pc-none {
    display: none;
  }
}
.card-box {
  width: 100%;
  max-width: 475px;
  padding: 50px;
  background: $surface; // W7-gate: flip card surface (was $white) so flipped text reads on #0D0D0D dark
  border: 1px solid $border; // W7-gate: hairline → #2E2E2E dark (was $border-hairline)
  box-shadow: $shadow-lg; // v2 card shadow (was hardcoded 0 14px 44px)
  border-radius: $radius-2xl; // v2 token (was 14px)
  position: relative;
  z-index: 1;

  @include tablet {
    padding: 30px;
  }
}
.box2 {
  margin-top: -90px;
}
.box3 {
  margin-top: -50px;
}
.box4 {
  margin-top: -60px;
}
.box-line {
  position: relative;
}
.box-line:before {
  content:"";
  position: absolute;
  height: 96px;
  width: 366px;
  content: url('#{$assets-cdn}/images/howitworks/line1.png');
  top: -9.1rem;
  left: -9.3rem;
  z-index: 0;
}
.box-line:after {
  content:"";
  position: absolute;
  height: 96px;
  width: 366px;
  content: url('#{$assets-cdn}/images/howitworks/line2.png');
  bottom:0;
  left:-26rem;
  z-index: 0;
}
.box-line2:after {
  bottom:-3rem;
}
.bg-step {
  background: transparent; // Wave 5A — show the page cream canvas (was hardcoded #fff band)
}
.linear-img {
  position: relative;
  margin-top:-120px;
  z-index: 0;
  .img-cover{
    display: block;
  }
}
.height-shadow {
  content: "";
  position: absolute;
  top: 0px;
  background: linear-gradient(180deg, $cream, rgba($cream, 0)); // fade photo top into the cream canvas (was #ffffff)
  height: 214px;
  width: 100%;
}
@include phone {
  .sp-none {
    display: none;
  }
  .card-box {
    max-width: 100%;
    padding: 30px;
    margin-bottom: 80px;
  }
  .box2,.box3,.box4 {
    margin-top: 0px;
  }
  .box-line:before {
    content:"";
    position: absolute;
    height: 83px;
    width: 9px;
    background: url('#{$assets-cdn}/images/howitworks/line1-small.png') no-repeat center / contain ;
    top: -7rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
  }
  .box-line:after {
    content:"";
    position: absolute;
    height: 83px;
    width: 9px;
    background: url('#{$assets-cdn}/images/howitworks/line2-small.png') no-repeat center / contain ;
    bottom:-7rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 0;
  }
  .height-shadow {
    top: -10px;
    height: 120px;
  }
  .linear-img {
    margin-top:-60px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1270px){
  .container {
    padding: 0;
    &-step {
      padding: 0 40px;
      max-width: 768px;
      margin: 0 auto;
    }

    .box1,.box3 {
      z-index: 2;
    }

    .card-box {
      max-width: 303px;
      padding: 30px;
      .box-line {
        &::before {
          left: -16.3rem;
        }
        &::after {
          left: -16.3rem;
          width: 215px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
